import MoreHorizIcon from "@mui/icons-material/MoreHorizRounded";
import { IconButton } from "@mui/material";
import { useState } from "react";
import type { ClientInfoExtended, ReportTemplate } from "../../../../../../api/types/svTypes.ts";
import { getEditReportTemplateUrl } from "../../reports/utilities/editReportUrl";
import ReportTemplateActions from "./ReportTemplateActions";

interface Props {
  template: ReportTemplate;
  companies: ClientInfoExtended[];
  readonly?: boolean;
  onTemplateSelected?: (template?: ReportTemplate) => void;
}

export default function ActionMenuButton({ template, companies, readonly, onTemplateSelected }: Props) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <IconButton
        onClick={(evt) => {
          setAnchorEl(evt.currentTarget);
          onTemplateSelected?.(template);
        }}
      >
        <MoreHorizIcon />
      </IconButton>
      <ReportTemplateActions
        open={!!anchorEl}
        anchorEl={anchorEl}
        template={template}
        onClose={() => {
          onTemplateSelected?.(undefined);
          setAnchorEl(null);
        }}
        getEditReportTemplateUrl={getEditReportTemplateUrl}
        readonly={readonly}
        companies={companies}
      />
    </>
  );
}
